<template>
  <div>
    <Row :gutter="8" type="flex" class="mx-0 p-0">
      <Col :span="7" class="pointer pt-15" v-if="!hideCheckbox">
        <Checkbox :disabled="disabled"
          :checked="disabled" v-model="checked">
          <Ellipsis :text="consignee.dropLocationLabel || consignee.dropLocationName || consignee.details.name" :length="20"/>
          <Tooltip class="item" effect="dark" placement="bottom-end" v-if="disableIfLRNotAvailable">
            <div slot="content" class="tooltipcontent">LR attachment missing</div>
            <svgicon name="icon-warning-circle" class="text-red" width="12" height="13" />
          </Tooltip>
        </Checkbox>
      </Col>
    <Col :span="15">
      <Form :inline="true" class="form-default form-multi mb-20">
        <FormItem label="Reported At">
          <DatePicker v-model="arrived"
            type="datetime"
            :picker-options="arrivedOption"
            :format="datePickerFormat"
            placeholder="Select Date and Time"
            :disabled="disabled || isAutoReached"
            @input="onArrived"
            :clearable="this.consignee.reported_at ? false:true"
            :default-time="defaultTime"
            :prefix-icon="isArrivedGeofenceDatePopulated"
            class="w175">
          </DatePicker>
        </FormItem>
        <FormItem label="POD DATE">
            <DatePicker v-model="dispatched"
            type="datetime"
            :picker-options="releaseOption"
            :format="datePickerFormat"
            placeholder="Select Date and Time"
            :disabled="disabled || disableIfLRNotAvailable"
            @input="onDispatched"
            :clearable="this.consignee.release_at ? false:true"
            :default-time="defaultTime"
            :prefix-icon="isDispatchedGeofenceDatePopulated"
            class="w175">
            </DatePicker>
        </FormItem>
        <div v-if="checked">
          <FormItem label="Unloading Start">
              <DatePicker v-model="unloadingStart"
                type="datetime"
                :picker-options="arrivedOption"
                :format="datePickerFormat"
                placeholder="Select Date and Time"
                :disabled="disabled || isAutoReached"
                @input="onUnloadingStart"
                :clearable="this.consignee.unloading_start_at ? false:true"
                :default-time="defaultTime"
                :prefix-icon="isArrivedGeofenceDatePopulated"
                class="w175">
              </DatePicker>
            </FormItem>
            <FormItem label="Unloading End">
              <DatePicker v-model="unloadingEnd"
                type="datetime"
                :picker-options="releaseOption"
                :format="datePickerFormat"
                placeholder="Select Date and Time"
                :disabled="disabled || isAutoReached"
                @input="onUnloadingEnd"
                :clearable="this.consignee.unloading_end_at ? false:true"
                :default-time="defaultTime"
                :prefix-icon="isDispatchedGeofenceDatePopulated"
                class="w175">
              </DatePicker>
            </FormItem>
          </div>
        </Form>
      </Col>
    </Row>
    <div v-if="showDestinationAttachments" class="list-form-switch mt-10">
      <label class="text-sm text-nowrap w-auto">{{ $t('INDENT_POD_ATTACHMENTS') }}<span v-if="isPodMandatory" class="text-red"> *</span></label>
        <Attachments
          class="ml-m15"
          :disableUpload="disabled"
          :attachments="consigneeAttachments"
          :showPreview="true"
          :disableDelete="true"
          @addAttachments="addAttachments">
        </Attachments>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { movementMapLower } from 'pando-constants';
import { oneDayMilliSeconds } from '../../../constants/order';
import Attachments from '@common/components/Attachments';

export default {
  components: {
    Attachments,
  },
  props: ['consignee', 'dispatch', 'movement', 'getBackDateConfig', 'datePickerFormat', 'isStorageLocation', 'hideCheckbox', 'orderNo'],
  data() {
    const dispatch = this.consignee.arrived_at;
    const truckDispatched = this.dispatch;
    const reportedDateAllow = this.getBackDateConfig.reported_date;
    const releaseDateAllow = this.getBackDateConfig.release_date;
    const currentDate = new Date();
    return {
      unloadingStart: null,
      unloadingEnd: null,
      arrived: null,
      dispatched: null,
      checked: false,
      attachmentList: [],
      attachmentIds: [],
      defaultTime: `${currentDate.getHours()}:${currentDate.getMinutes()}:00`,
      payload: {
        is_storage_location: false,
        destination_id: null,
        gate_id: null,
        arrived_at: null,
        dispatched_at: null,
        unloading_start_at: null,
        unloading_end_at: null,
      },
      arrivedOption: {
        disabledDate(time) {
          if (reportedDateAllow) {
            return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
          }
          return time.getTime() > Date.now() ||
            time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
        },
      },
      releaseOption: {
        disabledDate(time) {
          if (releaseDateAllow) {
            return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
          }
          if (!dispatch) {
            return time.getTime() > Date.now() ||
              time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
          }
          return time.getTime() > new Date() ||
            time.getTime() < new Date(dispatch).getTime() - oneDayMilliSeconds;
        },
      },
    };
  },

  created() {
    this.payload.destination_id = this.consignee.location_id;
    this.payload.gate_id = this.consignee.gate_id || null;
    this.arrived = this.fillReportedAt();
    this.dispatched = this.fillDispatchedAt();
    this.unloadingStart = this.$hasFeature('should_not_auto_populate_milestone_fields') ? this.consignee.unloading_start_at : this.consignee.unloading_start_at || this.arrived;
    this.unloadingEnd = this.consignee.unloading_end_at || this.dispatched;
    this.payload.is_storage_location = this.consignee.isStorageLocation;
    this.attachmentIds = (this.consignee && this.consignee.attachments && this.consignee.attachments.map(a => a.id)) || [];
    this.attachmentList = this.consignee.attachments || [];
    if (this.arrived) {
      this.onArrived(this.arrived);
    }
    if (this.dispatched) {
      this.onDispatched(this.dispatched);
    }
    if (this.unloadingStart) {
      this.onUnloadingStart(this.unloadingStart);
    }
    if (this.unloadingEnd) {
      this.onUnloadingEnd(this.unloadingEnd);
    }
  },

  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      isLrMandatoryForMarkAsDelivered: 'indentV2/isLrMandatoryForMarkAsDelivered',
    }),
    showDestinationAttachments() {
      return !this.$hasFeature('last_mile')
        && this.$hasFeature('destination_attachments_without_last_mile');
    },
    isPodMandatory() {
      return this.showDestinationAttachments && this.$hasFeature('mandatory_pod_for_grn');
    },
    consigneeAttachments() {
      return this.attachmentList || [];
    },
    getGeofenceReportedAt() {
      return this.configurations.autopopulate_geofence_time ?
        this.consignee.geofence_entry_time : null;
    },
    getGeofenceDispatchedAt() {
      return this.configurations.autopopulate_geofence_time ?
        this.consignee.geofence_exit_time : null;
    },
    disableIfLRNotAvailable() {
      return this.isLrMandatoryForMarkAsDelivered && this.movement &&
        this.isLrMandatoryForMarkAsDelivered[movementMapLower[this.movement]] &&
        !this.consignee.has_lr_attachment;
    },
    disabled() {
      return !!(this.consignee.reported_at && this.consignee.release_at);
    },
    allowReportedToBackDate() {
      return this.getBackDateConfig.reported_date;
    },
    allowReleaseToBackDate() {
      return this.getBackDateConfig.release_date;
    },
    isAutoReached() {
      // based on geofence, only when consignee_auto_reach_release flag is enabled in client settings
      const trackSetting = this.configurations.track_settings;
      if (trackSetting && trackSetting.consignee_auto_reach) {
        return !!(this.consignee.geofence_entry_time);
      }
      return false;
    },
    isGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if (((!this.consignee.reported_at && !!this.consignee.geofence_entry_time) ||
           (!this.consignee.release_at && !!this.consignee.geofence_exit_time))) {
          if (new Date(this.arrived).getTime() === new Date(this.consignee.geofence_entry_time).getTime() ||
              new Date(this.dispatched).getTime() === new Date(this.consignee.geofence_exit_time).getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    isArrivedGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if ((!this.consignee.reported_at && !!this.consignee.geofence_entry_time)) {
          if (new Date(this.arrived).getTime() === new Date(this.consignee.geofence_entry_time).getTime()) {
            return 'icon-location';
          }
        }
      }
      return 'el-icon-date';
    },
    isDispatchedGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if ((!this.consignee.release_at && !!this.consignee.geofence_exit_time)) {
          if (new Date(this.dispatched).getTime() === new Date(this.consignee.geofence_exit_time).getTime()) {
            return 'icon-location';
          }
        }
      }
      return 'el-icon-date';
    },
  },
  watch: {
    consignee() {
      this.arrived = (this.consignee && this.consignee.reported_at)
        ? new Date(this.consignee.reported_at) : this.arrived;
      this.dispatched = (this.consignee && this.consignee.release_at)
        ? new Date(this.consignee.release_at) : this.dispatched;
      this.unloadingStart = (this.consignee && this.consignee.unloading_start_at)
        ? new Date(this.consignee.unloading_start_at) : this.unloadingStart;
      this.unloadingEnd = (this.consignee && this.consignee.unloading_end_at)
        ? new Date(this.consignee.unloading_end_at) : this.unloadingEnd;
    },
  },

  methods: {
    async attachmentCall(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch('order/uploadDestinationAttachment', {
          orderNo: this.orderNo,
          destinationId: this.consignee.location_id,
          file: file.raw,
        });
        return result;
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('APP_CATCH_ERR') });
      }
      return null;
    },
    async addAttachments(file) {
      const result = await this.attachmentCall(file);
      if (!result || result.error) return;
      const data = result.data || result;
      const attachmentObj = {
        id: data.id,
        url: data.attachment_url,
      };
      this.attachmentList.push(attachmentObj);
      this.attachmentIds.push(data.id);
    },
    onUnloadingEnd(date) {
      this.unloadingEnd = date;
      this.payload.unloading_end_at = date;
      const keys = Object.keys(this.payload);
      const res = {};
      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      this.onChangeUpdate(res);
    },
    onUnloadingStart(date) {
      this.unloadingStart = date;
      this.payload.unloading_start_at = date;
      const keys = Object.keys(this.payload);
      const res = {};
      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      this.onChangeUpdate(res);
    },
    onArrived(date) {
      this.arrived = date;
      this.checked = true;
      this.payload.reported_at = this.arrived;
      if (!this.payload.release_at) {
        this.payload.release_at = this.consignee.release_at ? new Date(this.consignee.release_at) : '';
      }
      if (!this.unloadingStart || isNaN(this.unloadingStart) || this.allowReleaseToBackDate || date) {
        this.unloadingStart = this.$hasFeature('should_not_auto_populate_milestone_fields') ? this.unloadingStart : (this.unloadingStart || this.arrived);
        this.payload.unloading_start_at = this.unloadingStart;
      }
      this.payload.geofence_populated = this.isGeofenceDatePopulated;
      const keys = Object.keys(this.payload);
      const res = {};
      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      this.onChangeUpdate(res);
    },

    fillReportedAt() {
      if (this.consignee.reported_at) {
        return new Date(this.consignee.reported_at);
      }
      if (this.getGeofenceReportedAt) {
        return new Date(this.consignee.geofence_entry_time);
      }
      return '';
    },

    fillDispatchedAt() {
      if (this.consignee.release_at) {
        return new Date(this.consignee.release_at);
      }
      if (this.getGeofenceDispatchedAt) {
        return new Date(this.consignee.geofence_exit_time);
      }
      return '';
    },

    arrivedDateValidation(time) {
      if (this.reportedDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      return time.getTime() > Date.now() ||
        time.getTime() < new Date(this.truckDispatched).getTime() - oneDayMilliSeconds;
    },

    dispatchedDateValidation(time) {
      if (this.releaseDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      if (!this.dispatch) {
        return time.getTime() > Date.now() ||
          time.getTime() < new Date(this.truckDispatched).getTime() - oneDayMilliSeconds;
      }
      return time.getTime() > new Date() ||
        time.getTime() < new Date(this.dispatch).getTime() - oneDayMilliSeconds;
    },
    onChangeUpdate(res) {
      if (this.attachmentIds && this.attachmentIds.length) {
        res.attachment_ids = this.attachmentIds;
      }
      if (this.isStorageLocation) {
        if (this.consignee && this.consignee.isStorageLocation && this.consignee.combined_storage_gate_ids) {
          const ids = this.consignee.combined_storage_gate_ids.split(',');
          const data = [];
          ids.forEach((id) => {
            data.push({
              ...res,
              gate_id: id,
            });
            this.$emit('change', data);
          });
        } else {
          this.$emit('change', res);
        }
      } else {
        this.$emit('change', res);
      }
    },
    onDispatched(date) {
      this.dispatched = date;
      this.checked = true;
      this.payload.release_at = (this.allowReleaseToBackDate) ? new Date() : date;
      if (!this.payload.reported_at) {
        this.payload.reported_at = this.consignee.reported_at ? new Date(this.consignee.reported_at) : '';
      }
      if (!this.unloadingEnd || isNaN(this.unloadingEnd) || this.allowReleaseToBackDate || date) {
        this.unloadingEnd = this.dispatched;
        this.payload.unloading_end_at = this.payload.release_at;
      }
      this.payload.geofence_populated = this.isGeofenceDatePopulated;
      const keys = Object.keys(this.payload);
      const res = {};

      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      delete res.is_storage_location;
      this.onChangeUpdate(res);
    },
  },
};
</script>

<style lang="scss" scoped>
  .list-float {
    clear: both;
  }
</style>
<style lang="scss">
 @media (max-width: 1300px) {
  .el-form.form-default .el-form-item__content .el-date-editor .el-input__inner{
    padding-right: 5px;
  }
  .el-form.form-default .el-form-item__content .el-date-editor .el-input__inner{
    font-size: 10px !important;
  }
}
</style>
